"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyMatrixViewQueryStateField = exports.STRATEGY_MATRIX_VIEW_QUERY_STATE_VERSION = void 0;
exports.STRATEGY_MATRIX_VIEW_QUERY_STATE_VERSION = 1;
var StrategyMatrixViewQueryStateField;
(function (StrategyMatrixViewQueryStateField) {
    StrategyMatrixViewQueryStateField["Version"] = "version";
    StrategyMatrixViewQueryStateField["ProjectId"] = "projectId";
    StrategyMatrixViewQueryStateField["CatalogId"] = "catalogId";
    StrategyMatrixViewQueryStateField["ExtendedFilter"] = "extendedFilter";
    StrategyMatrixViewQueryStateField["SelectedAttributes"] = "selectedAttributes";
    StrategyMatrixViewQueryStateField["SelectedDisplayTable"] = "selectedDisplayTable";
    StrategyMatrixViewQueryStateField["TerminalNodeId"] = "terminalNodeId";
})(StrategyMatrixViewQueryStateField || (exports.StrategyMatrixViewQueryStateField = StrategyMatrixViewQueryStateField = {}));
